/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import React from "react";
import { connect } from "react-redux";
import { t } from "i18n";
import Header from "components/header/header";
import { saveAndLogout } from "pages/settings/pages/users-and-roles/users/action-creators";
import ConfirmationModal from "components/confirmation-modal/confirmation-modal";
import classnames from "classnames/bind";
import { selectIsDesktopSizeViewport } from "store/viewport";
import styles from "./header.module.css";
import WithGAEvent from "helpers/ga-analytics/with-ga-event";
import { withGAEvents } from "helpers/ga-analytics/helpers";

const cx = classnames.bind(styles);

class WorkspaceHeader extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { isConfirmationModalVisible: false };
    this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
  }

  toggleConfirmationModal() {
    this.setState((state: any) => ({
      isConfirmationModalVisible: !state.isConfirmationModalVisible
    }));
  }
  render() {
    const { user, isBoldUIEnabled, saveAndLogout } = this.props;

    const { onCancel, onClose, onConfirm }: any = withGAEvents({
      onCancel: [this.toggleConfirmationModal, "switch-to-classic-ui-cancel"],
      onClose: [this.toggleConfirmationModal, "switch-to-classic-ui-close"],
      onConfirm: [() => saveAndLogout({ ...user, settings: { bold: false } }), "switch-to-classic-ui-yes"]
    });

    return (
      <Header>
        {this.state.isConfirmationModalVisible && (
          <ConfirmationModal
            showConfirmationModal={true}
            headerText={t("users-and-roles.bold_switch_modal_message")}
            confirmButtonLabel={t("users-and-roles.modal_yes")}
            cancelButtonLabel={t("users-and-roles.modal_cancel")}
            onConfirm={onConfirm}
            onCancel={onCancel}
            onClose={onClose}
          />
        )}
        {!isBoldUIEnabled && this.props.isDesktopSizeViewport && (
          <WithGAEvent label="switch-to-classic-ui">
            <div className={cx("classic-switch")} onClick={this.toggleConfirmationModal}>
              {t("users-and-roles.classic_ui")}
            </div>
          </WithGAEvent>
        )}
      </Header>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.config.member,
    isBoldUIEnabled: state.features.isBoldUIEnabled,
    isDesktopSizeViewport: selectIsDesktopSizeViewport(state)
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    saveAndLogout: (user: any) => dispatch(saveAndLogout(user))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceHeader);
